<template>

  <GuideModal
    v-if="selected === all.GUIDE_MODAL"
  ></GuideModal>

  <VdpValidationModal
    v-else-if="selected === all.VDP_VALIDATE_MODAL"
  ></VdpValidationModal>

  <div v-else>MODAL NOT SELECTED!</div>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import pinia from '../core/pinia';
import { useModalStore } from '../stores';
import { E_MODAL } from '../types/modals.enum';
import GuideModal from '../components/modals/GuideModal.vue';
import VdpValidationModal from '../components/modals/VdpValidationModal.vue';


export default defineComponent({
  name: 'FlowAuModal',
  components: {
    GuideModal,
    VdpValidationModal,
  },
  props: {
    selected: {
      type: String,
      default: E_MODAL.DEFAULT,
    },
  },
  setup(props, { expose }) {
    const modalStore = useModalStore(pinia);
    
    function show() {
      const modalIds = modalStore.getModalIdsByName(props.selected);
      if (!modalIds.length) {
        throw new Error(`Modal '${props.selected}' not found'`);
      }
      modalStore.show(modalIds[0]);
    }

    const all = E_MODAL;

    expose({
      show,
    });

    return {
      show,
      all,
    };
  },
});
</script>

<style scoped lang="scss">
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
  z-index: 998;
  align-items: center;
  justify-content: center;
}

.modal-open {
  display: flex;
}

.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.modal-overlay {
  background-color: #fff;
  padding: 5px 10px;
  z-index: 1000;
  max-width: 80vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
</style>